import React, { Component } from "react";
import UsersContainer from "../../containers/users/index";
import UserContainer from "../../containers/users/User";
import { useParams } from "react-router-dom";

const UssersPage = () => {
	const { id } = useParams();

	return id ? <UserContainer id={id} /> : <UsersContainer />;
};

export default UssersPage;
